import React from 'react';

import H2 from 'components/typo/Heading/H2';
import P from 'components/typo/P';
import { useTranslation } from 'lib/i18n';

import sizeidAdvisorImage from '../images/sizeidAdvisor.png';
import sizeidForBusinessImage from '../images/sizeidForBusiness.png';
import sizeidBusinessApiImage from '../images/sizeidBusinessApi.png';
import sizeidBusinessAnalyticsImage from '../images/analytics.png';
import FileLink from '../files/link';

import {
  StyledWhiteBox,
  InnerContent,
  Buttons,
  MinimizeImage,
  Button,
  WhiteBoxWrapper,
} from './styled';

const ProductsIndex: React.FC = () => {
  const { t } = useTranslation('pages');
  return (
    <>
      <H2>{t('integration.guides.title')}</H2>
      <WhiteBoxWrapper>
        <StyledWhiteBox>
          <InnerContent>
            <MinimizeImage src={sizeidForBusinessImage} alt="sizeId docs" />
            <P>{t('integration.guides.business')}</P>
            <Buttons>
              <FileLink id="businessUserGuide">
                <Button outline>
                  {t('integration.guides.buttons.userGuide')}
                </Button>
              </FileLink>
            </Buttons>
          </InnerContent>
        </StyledWhiteBox>
        <StyledWhiteBox>
          <InnerContent>
            <MinimizeImage src={sizeidAdvisorImage} alt="sizeId docs" />
            <P>{t('integration.guides.advisor')}</P>
            <Buttons>
              <a
                href="http://demo.sizeid.com/advisor.products/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <Button outline>
                  {t('integration.guides.buttons.liveDemo')}
                </Button>
              </a>
              <FileLink id="advisorIntegrationGuide">
                <Button outline>
                  {t('integration.guides.buttons.integrationGuide')}
                </Button>
              </FileLink>
            </Buttons>
          </InnerContent>
        </StyledWhiteBox>
        <StyledWhiteBox>
          <InnerContent>
            <MinimizeImage src={sizeidBusinessApiImage} alt="sizeId docs" />
            <P>{t('integration.guides.businessAPI')}</P>
            <Buttons>
              <a
                href="http://demo.sizeid.com/api.dashboard/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <Button outline>
                  {t('integration.guides.buttons.liveDemo')}
                </Button>
              </a>

              <a
                href={`${URLS.api}/docs`}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Button outline>
                  {t('integration.guides.buttons.apiReference')}
                </Button>
              </a>

              <a
                href="https://github.com/sizeid/oauth2"
                rel="noopener noreferrer"
                target="_blank"
              >
                <Button outline>
                  <>SDK</>
                </Button>
              </a>
            </Buttons>
          </InnerContent>
        </StyledWhiteBox>
        <StyledWhiteBox>
          <InnerContent>
            <MinimizeImage
              src={sizeidBusinessAnalyticsImage}
              alt="sizeId analytics logo"
            />
            <P>{t('integration.guides.analytics.title')}</P>
            <Buttons>
              <FileLink id="analyticsIntegrationManual">
                <Button outline>
                  {t('integration.guides.analytics.integrationManual')}
                </Button>
              </FileLink>
            </Buttons>
          </InnerContent>
        </StyledWhiteBox>
      </WhiteBoxWrapper>
    </>
  );
};

export default ProductsIndex;
